 
import React from "react";
import { Link } from "react-router-dom";
import shape7 from "../../assets/images/shape/shape7.png";
import shape8 from "../../assets/images/shape/shape8.png";

export default function BreadcrumbSection() {
	return (
		<div className="fugu-breadcrumb-section">
			<div className="container">
				<div className="breadcrumbs">
					<h1 className="wow fadeInUpX" data-wow-delay="0s">
						Our Service
					</h1>
					<nav aria-label="breadcrumb" className="wow fadeInUpX" data-wow-delay="0.15s">
						<ol className="breadcrumb">
							<li className="breadcrumb-item">
								<Link to={"/"}>Home</Link>
							</li>
							<li className="breadcrumb-item active" aria-current="page">
								Our Service
							</li>
						</ol>
					</nav>
				</div>
			</div>
			<div className="fugu-shape8">
				<img src={shape7} alt="" />
			</div>
			<div className="fugu-shape9">
				<img src={shape8} alt="" />
			</div>
		</div>
	);
}
